<script>

    import layer3d from "@/mixins/threeBoxLayer"

    export default{

        mixins:[layer3d],
        
        name:"barcos",

        data(){
            return {
                loadDelay:2,
                modelName:"barco",
                modelDir:"/models3d/",
                rotation:[90,0,0,'ZXY'],
                scale:[15,15,15],
                zoomScaleFactor:[[9,12],[14,2],[15,1],[19,0.5]],
                coordinates: [-47.8288133263986,-15.702336959293092]
            }
        },

        computed:{

            geoJSON:function(){

                //list of main points
                var mainPoints = [
                    [-47.821868401167876,-15.77662226598963],
                    [-47.841027774313716,-15.774166320426673],
                    [-47.82298176124081,-15.80982296015064],
                    [-47.84521621894129,-15.829967590783838],
                    [-47.84861243804377,-15.830899786987985],
                    [-47.849879984289146,-15.824622137781944],
                ]

                var points = mainPoints// [];

                // _.each(mainPoints, pt=>{
                //     points.push(pt)
                //     for (let index = 0; index < _.random(1, 5); index++) {
                //         var dist = 0.01;
                //         var offsetX = _.random(-dist, +dist);
                //         var offsetY = _.random(-dist, +dist);
                //         points.push( [pt[0]+offsetX, pt[1]+offsetY])
                //     }
                // })


                var features = _.map(points, (point,index)=>{
                      
                      var scale = _.random(15,15); // (Math.random()*6)+9
                      return  {
                        "type": "Feature",
                        "geometry": {
                            "type": "Point",
                            "coordinates":point
                        },
                        "properties":{
                            key:"barco"+index+"three",
                            scale:[scale,scale,scale],//[5,5,5],
                            rotation:[90,0,Math.random()*360,'ZXY'],//[0,0,7,'XYZ'],
                            zoomScaleFactor:this.zoomScaleFactor,//[0,0,7,'XYZ'],
                        }
                    } 
                });

                // console.log(features);

                return {
                    "type": "FeatureCollection",
                    "features": features
                }
            },
        },


        watch:{
            geoJSON:function(){

                // this.animatePoints(4, false)
            }
        },

        methods:{

        },

        style: function () {
            return {
                "type": "symbol",
                "layout": {
                    "icon-image": ["get", "icon"], //['case', ['==',['get','index'],0], 'largada','pis'],  //"pis",
                    "icon-anchor": "center",
                    "icon-allow-overlap": true,
                    "icon-size": {
                        "base": 1,
                        "stops": [
                            [8.9, 0.1],
                            [11, 0.5],
                            [14, 1.3]
                        ]
                    },
                },
                "paint": {
                    "icon-opacity": {
                        "base": 1,
                        "stops": [[11.3, 0], [11.4, 1]],
                    },
                }
            }
        }
    }


</script>